module.exports = __webpack_public_path__ + "img/3198a04.jpg";